import { Reveal } from "@/components/landing/Reveal";

const CARDS = [
  {
    number: "01",
    title: "Awareness over guilt",
    copy: "Understand where your money goes without harsh restrictions or judgment.",
  },
  {
    number: "02",
    title: "Context over raw numbers",
    copy: "See what your spending could equal in real-life items and goals, so every amount means something.",
  },
  {
    number: "03",
    title: "Better habits, together",
    copy: "Manage shared costs and learn with friends, because money decisions are often social.",
  },
];

export const WhySplurge = () => {
  return (
    <section id="why" className="scroll-mt-20 bg-white py-24 lg:py-32">
      <div className="mx-auto max-w-7xl px-5 sm:px-8">
        <Reveal>
          <p className="text-xs font-extrabold uppercase tracking-[0.22em] text-splurge-primary">
            Why Splurge
          </p>
        </Reveal>
        <Reveal delay={80}>
          <h2 className="mt-4 max-w-3xl text-4xl font-extrabold leading-[1.08] tracking-tight text-splurge-ink sm:text-5xl">
            Your social life has a money story.{" "}
            <span className="text-splurge-primary">Splurge helps you see it clearly.</span>
          </h2>
        </Reveal>
        <Reveal delay={160}>
          <p className="mt-6 max-w-2xl text-base leading-relaxed text-splurge-ink/60 md:text-lg">
            It is built around the spending decisions students actually face, from splitting
            dinner to buying something because everyone else is.
          </p>
        </Reveal>

        <div className="mt-14 grid gap-5 md:grid-cols-3">
          {CARDS.map((card, i) => (
            <Reveal key={card.number} delay={i * 110}>
              <article
                data-testid={`why-card-${card.number}`}
                className="group h-full rounded-3xl border border-splurge-lavender bg-splurge-bg p-8 transition-all duration-300 hover:-translate-y-1.5 hover:border-splurge-violet/40 hover:shadow-xl hover:shadow-splurge-primary/10"
              >
                <span className="bg-gradient-to-br from-splurge-primary to-splurge-violet bg-clip-text text-4xl font-extrabold text-transparent">
                  {card.number}
                </span>
                <h3 className="mt-5 text-xl font-extrabold tracking-tight text-splurge-ink">
                  {card.title}
                </h3>
                <p className="mt-3 text-sm leading-relaxed text-splurge-ink/60 md:text-base">
                  {card.copy}
                </p>
                <span
                  aria-hidden="true"
                  className="mt-6 block h-1 w-10 rounded-full bg-splurge-lavender transition-all duration-300 group-hover:w-16 group-hover:bg-splurge-primary"
                />
              </article>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};
